import React, { useState } from 'react';
import styled from 'styled-components';


const NewsletterSection = styled.section`
  background: linear-gradient(145deg, #ffffff 0%, #f8f9fa 100%);
  padding: 100px 20px;
  position: relative;
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 100%;
    background: url('/pattern.svg') center/cover;
    opacity: 0.05;
    pointer-events: none;
  }

  @media (max-width: 480px) {
    padding: 80px 15px;
  }
`;

const NewsletterContainer = styled.div`
  max-width: 800px;
  margin: 0 auto;
  text-align: center;
  position: relative;
  z-index: 2;
`;

const NewsletterTitle = styled.h2`
  font-size: 2.5rem;
  font-weight: 700;
  color: #1e1b4b;
  margin-bottom: 1.5rem;
  
  span {
    color: #e63946;
  }
  
  @media (max-width: 480px) {
    font-size: 2rem;
  }
`;

const NewsletterDescription = styled.p`
  font-size: 1.1rem;
  color: #4a5568;
  line-height: 1.8;
  margin-bottom: 2.5rem;
  max-width: 600px;
  margin-left: auto;
  margin-right: auto;
  
  @media (max-width: 480px) {
    font-size: 1rem;
  }
`;

const NewsletterForm = styled.form`
  display: flex;
  gap: 1rem;
  max-width: 500px;
  margin: 0 auto;
  
  @media (max-width: 640px) {
    flex-direction: column;
  }
`;

const NewsletterInput = styled.input`
  flex: 1;
  padding: 1rem 1.5rem;
  border: 2px solid #e2e8f0;
  border-radius: 50px;
  font-size: 1rem;
  transition: all 0.3s ease;
  
  &:focus {
    outline: none;
    border-color: #e63946;
    box-shadow: 0 0 0 3px rgba(230, 57, 70, 0.1);
  }
`;

const NewsletterButton = styled.button`
  background: linear-gradient(45deg, #e63946 0%, #e63946dd 100%);
  color: white;
  padding: 1rem 2rem;
  border: none;
  border-radius: 50px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  white-space: nowrap;
  
  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(230, 57, 70, 0.2);
  }
  
  &:active {
    transform: translateY(0);
  }
  
  @media (max-width: 480px) {
    padding: 0.9rem 1.8rem;
    font-size: 0.9rem;
  }
`;

const SuccessMessage = styled.div`
  color: #059669;
  background: #d1fae5;
  border-radius: 8px;
  padding: 1rem;
  margin-top: 1rem;
  display: ${props => props.$show ? 'block' : 'none'};
`;

export default function Newsletter() {
  const [email, setEmail] = useState('');
  const [showSuccess, setShowSuccess] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    // Aquí iría la lógica para enviar el email a tu backend/servicio
    console.log('Email enviado:', email);
    // Simulamos éxito
    setShowSuccess(true);
    setEmail('');
    // Ocultamos el mensaje después de 5 segundos
    setTimeout(() => {
      setShowSuccess(false);
    }, 5000);
  };

return (
<NewsletterSection>
<NewsletterContainer>
  <NewsletterTitle>
    Mantente al día con nuestras <span>novedades</span>
  </NewsletterTitle>
  <NewsletterDescription>
    Suscríbete a nuestro newsletter y recibe las últimas actualizaciones,
    consejos de entrenamiento y ofertas exclusivas directamente en tu bandeja de entrada.
  </NewsletterDescription>
  <NewsletterForm onSubmit={handleSubmit}>
    <NewsletterInput
      type="email"
      placeholder="Tu correo electrónico"
      value={email}
      onChange={(e) => setEmail(e.target.value)}
      required
    />
    <NewsletterButton type="submit">
      Suscribirse
    </NewsletterButton>
  </NewsletterForm>
  <SuccessMessage $show={showSuccess}>
    ¡Gracias por suscribirte! Pronto recibirás nuestras novedades.
  </SuccessMessage>
</NewsletterContainer>
</NewsletterSection>
);
};

